module.exports = __webpack_public_path__ + "static/media/LightBlue-B.d05a0114.png";